import { render } from "./Chapter.vue?vue&type=template&id=dd61184a&scoped=true"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=dd61184a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-dd61184a"

export default script